module.exports = __webpack_public_path__ + "static/media/SVGReports.7464f12b.svg";